var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotesLight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 100 100",
    height: "100px",
    id: "Layer_1",
    viewBox: "0 0 100 100",
    width: "100px",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null)), /*#__PURE__*/React.createElement("g", null)))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    fill: "#ffffff",
    height: 2,
    width: 28,
    x: 34,
    y: 41
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.202,
    cy: 42,
    fill: "#ffffff",
    r: 2
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#ffffff",
    height: 2,
    width: 28,
    x: 34,
    y: 51
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.202,
    cy: 52,
    fill: "#ffffff",
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.202,
    cy: 62,
    fill: "#ffffff",
    r: 2
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#ffffff",
    height: 2,
    width: 16,
    x: 34,
    y: 71
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.202,
    cy: 72,
    fill: "#ffffff",
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.796,36.109l-2.828-2.828L87.2,35.049l-0.707-0.707l-2.755,2.651L74,46.63V30   c0-6.617-5.179-12-11.796-12H61v-1c0-1.1-0.696-2-1.796-2h-11c0-2.209-1.791-4-4-4s-4,1.791-4,4h-11C28.104,15,27,15.9,27,17v1   h-0.796C19.587,18,14,23.383,14,30v50c0,6.617,5.587,12,12.204,12h36C68.821,92,74,86.617,74,80V55.114L87.098,42h0.051   l3.562-3.476l-0.695-0.678L91.796,36.109z M44.204,13c1.104,0,2,0.896,2,2s-0.896,2-2,2s-2-0.896-2-2S43.1,13,44.204,13z M70,80   c0,4.411-3.385,8-7.796,8h-36C21.793,88,18,84.411,18,80V30c0-4.411,3.793-8,8.204-8h1l-1,4c0,1.1,0.9,2,2,2h32c1.1,0,2-0.9,2-2   l-1-4h1C66.615,22,70,25.589,70,30v20.63L59.835,61H34v2h23.835l-2.278,2.278l-1.768,3.889l-0.001,0l-1.768,3.89l7.677-3.537   L70,59.114V80z M58.233,69.369l-2.916,1.326l-0.936-0.935l1.326-2.917l2.324,2.323L58.233,69.369z M87.376,40.528L84.548,37.7   l1.794-1.793l-0.202,0.202l2.827,2.827l0.354-0.354l0.001,0.001L87.376,40.528z",
    fill: "#ffffff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotesLight);
export default __webpack_public_path__ + "static/media/notes_light.73866beac1e190f1c17848aa0c357ab9.svg";
export { ForwardRef as ReactComponent };